export const URL_PREFIX = '/shop';
export const URL_PREFIX_WITHOUT_SLASH = 'shop';
